function insertStepLabel({ root = document, summarySelector, markerClass, text }) {
	const summary = root.querySelector(summarySelector)
	if (!summary || root.querySelector(`.${markerClass}`)) {
		return
	}

	const step = document.createElement('p')
	step.className = `${markerClass}`
	step.textContent = text
	summary.insertAdjacentElement('beforebegin', step)
}

export function enhanceCartStepLabel() {
	insertStepLabel({
		summarySelector: '.wp-block-woocommerce-cart-order-summary-block',
		markerClass: 'checkout-step',
		text: 'Step 1 of 2',
	})
}

export function enhanceCheckoutStepLabel(root) {
	insertStepLabel({
		root,
		summarySelector: '.wp-block-woocommerce-checkout-order-summary-block',
		markerClass: 'checkout-step',
		text: 'Step 2 of 2',
	})
}

export function initCartStepLabel() {
	const root =
		document.querySelector('.wp-block-woocommerce-cart') ||
		document.querySelector('.wc-block-cart') ||
		document.body

	const run = () => enhanceCartStepLabel()
	run()

	let timeout = null
	new MutationObserver(() => {
		clearTimeout(timeout)
		timeout = setTimeout(run, 75)
	}).observe(root, { childList: true, subtree: true })
}
